<div class="position-relative dg-ag-dialog">
  <div class="row mb-4 position-absolute top-0 end-0 dg-z-index">
    <div class="col">
      <!-- <mat-card-title class="modal-Title">{{componentName}}</mat-card-title> -->
    </div>
    <div class="col text-end test">
      <button mat-button mat-dialog-close (click)="onNoClick()">
        <mat-icon color="primary">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="mat-typography dg-dialog-height">
    <ng-container
      *ngIf="componentName == 'AppGenMainComponent'"
      ;
      else
      customComponent
    >
      <app-app-gen-main
        [appRefId]="modalData.appRefId"
        [formId]="modalData.formId"
        [data]="modalData.data"
        [parentEventData]="modalData.parentEventData"
        [caseVO]="modalData.caseVO"
        [cases]="modalData.cases"
        [appGenSource]="modalData.appGenSource"
        [dataForPost]="modalData.dataForPost"
        [menuFetchData]="modalData.menuFetchData"
        [additionalVOList]="modalData.additionalVOList"
        [parentCommonService]="modalData?.parentCommonService"
      >
      </app-app-gen-main>
    </ng-container>
    {{ modalData.rowData }}
    <div *ngIf="componentName != 'AppGenMainComponent'">
      <ng-template
        #customComponent
        [componentLoader]="componentName"
        [componentInputs]="{
          data: modalData.data,
          parentEventData: modalData.parentEventData,
          caseVO: modalData.caseVO,
          cases: modalData.cases,
          dataForPost: modalData.dataForPost,
          menuFetchData: modalData.menuFetchData,
          formId: modalData.formId,
          appRefId: modalData.appRefId,

          additionalVOList: modalData.additionalVOList
        }"
        [componentOutputs]="[]"
        (output)="getChckLstComponentData($event)"
        [id]="'comp' + res?.fieldId"
      ></ng-template>
    </div>
  </mat-dialog-content>
  <!-- <mat-dialog-actions class="text-end">
      
     
    </mat-dialog-actions> -->
</div>
